import { Grid, Skeleton } from '@mui/material'
import React from 'react'
import styles from "../../../../../assets/styles/componentStyles/chats/smartAssist.module.scss";


interface SmartAssistSkeletonCardProps {
    index: number,
} 

const SmartAssistSkeletonCard: React.FC<SmartAssistSkeletonCardProps> = (props) => {
    
    const { index } = props;
    
    return (
        <>
            <Grid item key={index} className={styles.smartAssistSkeletonCard}>
                <Grid container justifyContent={"space-between"} alignItems={"center"} className={styles.smartAssistSkeletonHeader}>
                    <Skeleton variant="text" width="150px" height={24} />
                    <Skeleton variant="rectangular" width="45px" height={24} className={styles.skeletonRectRadius4} />
                </Grid>
                <Skeleton variant="text" width="100%" height={20} className={styles.skeletonTextMarginBottom} />
                <Skeleton variant="rectangular" width="100%" height={40} className={styles.skeletonRectRadius8} />
            </Grid>
        </>
    )
}

export default SmartAssistSkeletonCard
